import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface DropModel {}

export interface DropListRequest {
    from: string
    to: string
}

export interface DropParcelsRequest {
    suite_id: number
    parcel_ids: number[]
}

const dropApi = (apiInstance: AxiosInstance) => {
    const dropsList = async ({ warehouse }: { warehouse?: string }): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.get(`/parcels/suites-drop?warehouse=${warehouse}`)
        return res
    }

    const dropParcels = async (dropParcelsRequestData: DropParcelsRequest): Promise<GenericResponse> => {
        const res: Promise<GenericResponse> = apiInstance.post(`/parcels/multi-drop`, dropParcelsRequestData)
        return res
    }

    return {
        dropsList,
        dropParcels
    }
}

export default dropApi
